import { sendUserAttributeVerificationCode, updateUserAttribute } from 'aws-amplify/auth';
import { gql, useMutation } from '@apollo/client';
import { UPDATE_USER } from 'apollo/mutations/Client';
import { useModalStore, Modal } from 'stores/modal/useModalStore';

export const usePhoneVerification = (user, getPhone) => {
  const { open } = useModalStore();
  const [updateUser] = useMutation(gql(UPDATE_USER));

  const onVerifyCodeModal = async () => {
    open(Modal.VerifyPhoneCode);

    try {
      const currentPhone = getPhone();
      if (currentPhone === user.phone && !user.isPhoneVerified) {
        await sendUserAttributeVerificationCode({
          userAttributeKey: 'phone_number',
        });
      } else {
        await updateUserAttribute({
          userAttribute: {
            attributeKey: 'phone_number',
            value: currentPhone,
          },
        });
        
        await updateUser({
          variables: {
            input: {
              phone: currentPhone || user.phone,
            },
          },
          refetchQueries: ['ClientQuery'],
        });
        
        await sendUserAttributeVerificationCode({
          userAttributeKey: 'phone_number',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return { onVerifyCodeModal };
};
